import api from './api';

export const lookupService = {
  getRegistrationLookups: async () => {
    const response = await api.get('/lookups/registration-lookups');
    return response.data;
  },

  getLookupsByCategory: async (category) => {
    const response = await api.get(`/lookups/category/${encodeURIComponent(category)}`);
    return response.data;
  },
};

export default lookupService;
